import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import AssignTodoModal from "components/Market/Jobs/AssignTodoModal";

import * as marketReducer from "containers/Market/MarketReducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as adminReducer from "containers/Admin/reducer";
import * as projectReducer from "containers/Project/reducer";

class AssignTodoContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return <AssignTodoModal {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    createTodo: (todo) => dispatch(marketReducer.createTodo(todo)),
    assignTodo: (todo) => dispatch(marketReducer.assignTodo(ownProps.id, todo))
  };
};

const mapStateToProps = (state, ownProps) => {
  const project = nextReducer.getProject(state, ownProps.id);

  return {
    todo: marketReducer.getAssignTodo(state),
    users: adminReducer.getUsers(state),
    activeSegment: nextReducer.getActiveSegment(state, ownProps.id),
    project: project,
    segmentColor: projectReducer.getSegmentColor(state, project?.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(AssignTodoContainer);
